
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governance/democracy/[id]",
      function () {
        return require("private-next-pages/governance/democracy/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/governance/democracy/[id]"])
      });
    }
  